var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.loading)?_c('div',{staticClass:"offer"},[_c('div',{staticClass:"container",domProps:{"innerHTML":_vm._s(_vm.content)}})]):_c('div',{staticClass:"offer"},[_vm._v(" Загрузка... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }